<script setup lang="ts">
// 첫 실행 안내(3단계). 끝나면 다시 안 보인다.
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUiStore } from '../stores/ui'

const { t } = useI18n()
const ui = useUiStore()
const step = ref(0)
function next() { if (step.value < 2) step.value++; else ui.setOnboarded() }
</script>

<template>
  <div class="onb">
    <div class="onb-card">
      <div class="onb-slide" :key="step">
        <h1>{{ t('onb.t' + step) }}</h1>
        <p>{{ t('onb.d' + step) }}</p>
      </div>
      <div class="onb-dots"><i v-for="s in [0, 1, 2]" :key="s" :class="{ on: s === step }"></i></div>
      <button class="onb-btn" @click="next">{{ step < 2 ? t('onb.next') : t('onb.start') }}</button>
      <button v-if="step < 2" class="onb-skip" @click="ui.setOnboarded()">{{ t('onb.skip') }}</button>
    </div>
  </div>
</template>
